import React from 'react';
import { useTokens } from '../../context/TokenContext';
import { Sparkles, Crown } from 'lucide-react';

export const TokenBadge: React.FC = () => {
  const { balance, isPro, tier, canClaimStreak, openPurchaseModal } = useTokens();

  return (
    <button
      type="button"
      onClick={() => openPurchaseModal(isPro ? 'packs' : 'pro')}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        padding: '4px 10px',
        borderRadius: '9999px',
        background: isPro
          ? 'linear-gradient(135deg, rgba(234, 179, 8, 0.22) 0%, rgba(245, 158, 11, 0.15) 100%)'
          : 'linear-gradient(135deg, rgba(168, 85, 247, 0.18) 0%, rgba(139, 92, 246, 0.12) 100%)',
        border: isPro
          ? '1px solid rgba(234, 179, 8, 0.55)'
          : '1px solid rgba(168, 85, 247, 0.4)',
        color: '#ffffff',
        fontSize: '0.82rem',
        fontWeight: 700,
        cursor: 'pointer',
        boxShadow: isPro
          ? '0 0 12px rgba(234, 179, 8, 0.25)'
          : '0 0 10px rgba(168, 85, 247, 0.2)',
        transition: 'all 0.15s ease',
        position: 'relative'
      }}
      title={`Token Balance: ${balance}. Click to purchase tokens or manage Creator Pro membership.`}
    >
      {isPro ? (
        <Crown size={14} color="#facc15" />
      ) : (
        <Sparkles size={14} color="#c084fc" />
      )}

      <span style={{ color: isPro ? '#fef08a' : '#f3e8ff', letterSpacing: '0.01em' }}>
        {balance}
      </span>

      <span style={{ fontSize: '0.72rem', color: isPro ? '#fde047' : '#d8b4fe', fontWeight: 600 }}>
        Tkns
      </span>

      {isPro && (
        <span
          style={{
            fontSize: '0.65rem',
            padding: '1px 5px',
            borderRadius: '4px',
            background: 'linear-gradient(135deg, #eab308 0%, #ca8a04 100%)',
            color: '#000000',
            fontWeight: 800,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            marginLeft: '2px'
          }}
        >
          PRO
        </span>
      )}

      {/* Pulsing indicator if daily streak is ready to claim */}
      {canClaimStreak && (
        <span
          style={{
            position: 'absolute',
            top: '-3px',
            right: '-3px',
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            background: '#22c55e',
            boxShadow: '0 0 8px #22c55e',
            animation: 'pulse 1.8s infinite'
          }}
          title="Daily Streak ready to claim (+1 Free Token)!"
        />
      )}
    </button>
  );
};
